// order-fork:create-store-import:start

// order-fork:create-store-import:end
import jyorder from './jyorder'
import kkrenJyorder from './kkrenJyorder'
import kkrenVaorder from './kkrenVaorder'
import jyorderPoll from './jyorderPoll'
import cnorder from './cnorder'
import vaorder from './vaorder'
import jyorderShare from './jyorderShare'
import jyorderdtl from './jyorderdtl'
import jyorderBat from './jyorderBat'
import jyorderPay from './jyorderPay'
import sea from './sea'
import checkPreApntd from './checkPreApntd'
import jyorderCardwt from './jyorderCardwt'

// order-fork:create-store-selector:start
const createStoreModules = process.env.project === 'mgb-h5' || process.env.project === 'mgb-pc'
  ? { jyorderCreateMgb: require('./jyorderCreateMgb').default }
  : { jyorderCreate: require('./jyorderCreate').default }
// order-fork:create-store-selector:end
const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    // order-fork:create-store-module:start
    ...createStoreModules,
    // order-fork:create-store-module:end
    jyorder,
    kkrenJyorder,
    kkrenVaorder,
    jyorderPoll,
    cnorder,
    vaorder,
    jyorderShare,
    jyorderdtl,
    jyorderBat,
    jyorderPay,
    sea,
    checkPreApntd,
    jyorderCardwt,
  }
}
